import { createIcon } from '@/assets/icons/helper.tsx';

export const MedicalBriefcase = createIcon(
  <>
    <g clipPath="url(#clip0_452_16453)">
      <mask
        id="mask0_452_16453"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="32"
        height="32"
      >
        <path d="M32 0H0V32H32V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_452_16453)">
        <path
          d="M0 8.4002C0 7.73745 0.537258 7.2002 1.2 7.2002H30.8C31.4627 7.2002 32 7.73745 32 8.4002V30.8002C32 31.4629 31.4627 32.0002 30.8 32.0002H1.2C0.537259 32.0002 0 31.4629 0 30.8002V8.4002Z"
          fill="#FFE1B2"
        />
        <path
          d="M9.20014 16.4004C9.64198 16.4004 10.0001 16.7586 10.0001 17.2004V20.4004H13.2001C13.642 20.4004 14.0001 20.7586 14.0001 21.2004V22.8004C14.0001 23.2422 13.642 23.6004 13.2001 23.6004H10.0001V26.8004C10.0001 27.2422 9.64198 27.6004 9.20014 27.6004H7.60017C7.15835 27.6004 6.80017 27.2422 6.80017 26.8004V23.6004H3.60017C3.15835 23.6004 2.80017 23.2422 2.80017 22.8004V21.2004C2.80017 20.7586 3.15835 20.4004 3.60017 20.4004H6.80017V17.2004C6.80017 16.7586 7.15835 16.4004 7.60017 16.4004H9.20014Z"
          fill="#FFA71F"
        />
        <path
          d="M29.2 13.5996H17.6C17.1582 13.5996 16.8 13.9578 16.8 14.3996V29.1996C16.8 29.6414 17.1582 29.9996 17.6 29.9996H29.2C29.6419 29.9996 30 29.6414 30 29.1996V14.3996C30 13.9578 29.6419 13.5996 29.2 13.5996Z"
          fill="url(#paint0_linear_452_16453)"
        />
        <path
          d="M23.4 22.7998C26.8568 22.7998 29.6923 25.6988 29.9762 29.3896C29.8909 29.7397 29.5764 29.9998 29.2 29.9998H17.6C17.2237 29.9998 16.9088 29.7397 16.8235 29.3896C17.1074 25.6988 19.9433 22.7998 23.4 22.7998Z"
          fill="#FFA71F"
        />
        <path
          d="M23.6 15.5996C25.3673 15.5996 26.8 17.0323 26.8 18.7996C26.8 20.5669 25.3673 21.9996 23.6 21.9996C21.8327 21.9996 20.4 20.5669 20.4 18.7996C20.4 17.0323 21.8327 15.5996 23.6 15.5996Z"
          fill="#FFA71F"
        />
        <path
          d="M19.6 0C20.0419 1.03081e-07 20.4 0.358172 20.4 0.8V7.2C20.4 9.40912 18.6091 11.2 16.4 11.2C14.1909 11.2 12.4 9.40912 12.4 7.2V0.8C12.4 0.358172 12.7582 6.44255e-09 13.2 0H19.6Z"
          fill="url(#paint1_linear_452_16453)"
        />
        <path
          d="M16.4 9.5998C17.7255 9.5998 18.8 8.52529 18.8 7.1998C18.8 5.87432 17.7255 4.7998 16.4 4.7998C15.0745 4.7998 14 5.87432 14 7.1998C14 8.52529 15.0745 9.5998 16.4 9.5998Z"
          fill="#FFFCF2"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_452_16453"
        x1="23.2"
        y1="0.399609"
        x2="23.4"
        y2="29.9996"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFA71F" />
        <stop offset="1" stopColor="#FFE1B2" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_452_16453"
        x1="16.4"
        y1="0"
        x2="16.4"
        y2="11.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE1B2" />
        <stop offset="1" stopColor="#FFA71F" />
      </linearGradient>
      <clipPath id="clip0_452_16453">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </>,
  '0 0 32 32',
  'MedicalBriefcase'
);
